<template>
  <div :class="['form-layout-run', showGroupNav && 'group-nav']">
    <div class="form-layout-run-content" v-show="showRcForm">
      <div class="title" v-if="title==='process'&&!nodeTabEnable">
        <label class="component-title">{{component.name}}</label>
      </div>
      <div class="layout-form">
        <el-form ref="form" :class="{'isDisabled':disable}" :model="value" :label-width="dialogWidth==='small'?'86px':'100px'" :disabled="disable" @submit.native.prevent>
          <div
            class="list-component-item"
            v-for="component in component.children"
            :key="component.id">
            <component
              ref="children"
              v-if="!component.properties.hidden || component.properties.seat"
              :style="(component.properties.hidden && component.properties.seat) ? {opacity:0} : ''"
              :is="component.componentType"
              :component="component"
              :value="getChildrenData(component)"
              :parentPath="getCurrentPath()"
              :disabled="disable"
              :dialogWidth="dialogWidth"
              @input="(buildData) => updateChildValue(component.archive.columnId, buildData)"
              @initRelated="(component, callback) => callbackRelated(component, {'callback': callback})"
              @initDefaultValue="(component, callback) => callbackDefault(component, {'callback': callback})"
              @calculation="(expression) => calculation(expression)">
            </component>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {containerInitMixin, componentMixin, containerMixin, calculationMixin, relFunMixin, defaultValueMixin} from './mixins'
import {ruleGenerator} from './rule'
import {childrenSortMixin} from '@/components/shared/designAndRuntimeMixins/mixins.js'
import {findVueMixin} from './findVue.js'
import RcGroup from './rc-group.vue'
import RcLayout from './rc-layout.vue'
import RcMultipleTabs from './rc-multiple-tabs'

export default {
  name: 'rc-form',
  mixins: [childrenSortMixin, componentMixin, containerMixin, calculationMixin, relFunMixin, ruleGenerator, defaultValueMixin, containerInitMixin, findVueMixin],
  props: ['component', 'value', 'disable', 'dialogWidth', 'title', 'parentComponent', 'showGroupNav', 'nodeTabEnable'],
  data () {
    return {
      margin: [20, 16],
      cols: 4,
      maxRows: 100,
      rowHeight: 40,
      tableFlag: ''
      // rules: this.buildFormRule()
    }
  },
  components: {
    RcGroup,
    RcLayout,
    RcMultipleTabs
  },
  created () {
    this.sortComponent()
    document.onkeydown = (event) => {
      let e = event || window.event
      if (e && e.keyCode === 9) {
        this.getDom()
      }
    }
  },
  computed: {
    showRcForm () {
      return !this.component.properties.hidden
    }
  },
  methods: {
    // 自动聚焦第一个可用,可聚焦组件
    firstInputFocus (component = this.component) {
      let firstComponent
      let noFocusComponent = ['rc-form', 'rc-layout', 'rc-group', 'rc-draggable', 'rc-coding', 'rc-flowing-water']
      let allowFocusComponent = ['rc-input', 'rc-textarea', 'rc-numeric']
      if (component) {
        // 找到第一个非隐藏,非容器,非只读的控件(编码框和流水框没有只读属性,导致程序认为他们非只读,但是他们是写死只读的,此类需要排除)
        firstComponent = component.find(e => {
          if (!noFocusComponent.includes(e.componentType) && !e.properties.hidden && !e.properties.readonly && !this.disable) {
            return true
          }
        })
        if (!firstComponent && component.children) {
          return this.firstInputFocus(component.children)
        }
      }
      // 如果是文本框,大文本框,数字框 则聚焦
      if (firstComponent && firstComponent.componentId && allowFocusComponent.includes(firstComponent.componentType)) {
        let myComponent = this.findAllVue(this).find(e => e.component.componentId === firstComponent.componentId)
        myComponent.$el.querySelector('input') && myComponent.$el.querySelector('input').focus()
        myComponent.$el.querySelector('textarea') && myComponent.$el.querySelector('textarea').focus()
      }
    },
    sortComponent () {
      this.childrenSort(this.component)
    },
    validate () {
      return this.$refs.form.validate()
    },
    makeArray (obj) {
      return Array.prototype.slice.call(obj, 0)
    },
    getTableClassName (dom) {
      let className
      let grandparentDom = dom.parentElement.parentElement.parentElement.parentElement.parentElement
      if (grandparentDom.className === 'rc-combobox') {
        className = grandparentDom.parentElement.parentElement.className
      } else {
        className = grandparentDom.className
      }
      if (className && className.includes('table')) {
        return className
      } else {
        return null
      }
    },
    getDom () {
      let myTabIndex
      let myTableFlag
      let tableClassName
      let tableInputIndex
      let layout = this.makeArray(document.getElementsByClassName('layout-runtime'))
      for (let i = 0; i < layout.length; i++) {
        for (let j = 0; j < layout[i].children.length; j++) {
          let myForm = this.makeArray(layout[i].children[j].querySelectorAll('input,textarea'))
          for (let k = 0; k < myForm.length; k++) {
            tableClassName = this.getTableClassName(myForm[k])
            switch (j) {
              case 0:
                if (k === 0) {
                  myForm[k].setAttribute('tabindex', 1 + i * 1000)
                  myTabIndex = 1 + i * 1000
                } else {
                  myForm[k].setAttribute('tabindex', k * 10 + i * 1000)
                  myTabIndex = k * 10 + i * 1000
                }
                break
              case 1:
                if (k === 0) {
                  myForm[k].setAttribute('tabindex', 2 + i * 1000)
                  myTabIndex = 2 + i * 1000
                } else {
                  myForm[k].setAttribute('tabindex', k * 10 + 4 + i * 1000)
                  myTabIndex = k * 10 + 4 + i * 1000
                }
                break
              case 2:
                if (k === 0) {
                  myForm[k].setAttribute('tabindex', 3 + i * 1000)
                  myTabIndex = 3 + i * 1000
                } else {
                  myForm[k].setAttribute('tabindex', k * 10 + 5 + i * 1000)
                  myTabIndex = k * 10 + 5 + i * 1000
                }
                break
              case 3:
                if (k === 0) {
                  myForm[k].setAttribute('tabindex', 4 + i * 1000)
                  myTabIndex = 4 + i * 1000
                } else {
                  myForm[k].setAttribute('tabindex', k * 10 + 6 + i * 1000)
                  myTabIndex = k * 10 + 6 + i * 1000
                }
                break
              default:
                myForm[k].setAttribute('tabindex', j + 1 + i * 1000)
                myTabIndex = j + 1 + i * 1000
                break
            }
            if (tableClassName) {
              myTableFlag = tableClassName.match('(?<=_).*?(?=_)')[0]
              if (this.tableFlag !== myTableFlag) {
                this.tableFlag = myTableFlag
                tableInputIndex = myTabIndex
              }
              myForm[k].setAttribute('tabindex', tableInputIndex)
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .form-layout-run {
    margin-bottom: 15px;
    &.group-nav{
      margin-left: 110px;
      @media (min-width: 1366px){
        margin-left: 134px;
      }
    }

   >.title {
     padding-bottom: 15px;
     position: relative;
     color: #1A1A1A;
     padding-left: 10px;

     &::before {
       content: "";
       width: 2px;
       height: 14px;
       background: #54abf1;
       position: absolute;
       left: 0;
       top: 3px;
     }
   }
   .el-input.is-disabled .el-input__inner {
      background: #f5f5f5;
      border:1px solid #c2c3c4;
      color: #181818;
    }
   .layout-form {
     padding-left: 24px;
     >.el-form >.list-component-item{
       padding: 0 2px;
     }
     .list-component-item {
       padding: 8px 2px;
       &:last-child {
         margin-bottom: 0;
       }

       .el-form-item {
         margin: 0;
          .component-explain-tooltip {
            position: absolute;
            left: -9px;
            top: 8px;
          }
         .el-form-item__label {
           .control-label {
             font-size: 13px;
             white-space: pre-line;
             width: 100%;
             height: 28px;
             line-height: 15px;
             word-wrap: break-word;
             word-break: break-all;
             text-align: right;
           }
           .text-justify {
             text-align: justify;
           }
           .control-required {
             width: calc(100% - 2px);
           }
           .text-letter-spacing {
             letter-spacing: 1px;
             display: flex;
             align-items: center;
           }
         }
         .el-form-item__content{
            padding-left: 12px;
           .el-input.clear-padding,.el-select.clear-padding,.el-textarea.clear-padding{
             input,textarea{
               padding: 0;
             }
           }
         }
       }
       .el-form-item.to-top {
         margin: -8px 0 0 0;
         .component-explain-tooltip {
           position: absolute;
           left: 90px;
           top: -21px;
         }
         .el-form-item__label {
           margin-left: 8px;
           .control-label {
             font-size: 13px;
             white-space: pre-line;
             width: 100%;
             height: 28px;
             line-height: 15px;
             word-wrap: break-word;
             word-break: break-all;
             text-align: right;
           }
           .text-justify {
             text-align: justify;
           }
           .control-required {
             width: calc(100% - 2px);
           }
           .text-letter-spacing {
             letter-spacing: 1px;
             display: flex;
             align-items: center;
           }
         }
         .el-form-item__content{
           margin-left: 7px !important;
           padding-left: 5px;
           .el-input.clear-padding,.el-select.clear-padding,.el-textarea.clear-padding{
             input,textarea{
               padding: 0;
             }
           }
         }
       }
       .el-form-item.hidden {
         margin: 0;
         .component-explain-tooltip {
           position: absolute;
           left: -6px;
           top: 8px;
         }
         .el-form-item__label {
           .control-label {
             font-size: 13px;
             white-space: pre-line;
             width: 100%;
             height: 28px;
             line-height: 15px;
             word-wrap: break-word;
             word-break: break-all;
             text-align: right;
           }
           .text-justify {
             text-align: justify;
           }
           .control-required {
             width: calc(100% - 2px);
           }
           .text-letter-spacing {
             letter-spacing: 1px;
             display: flex;
             align-items: center;
           }
         }
         .el-form-item__content{
           margin-left: 0px !important;
           padding-left: 12px;
           .el-input.clear-padding,.el-select.clear-padding,.el-textarea.clear-padding{
             input,textarea{
               padding: 0;
             }
           }
         }
       }

       .el-form-item__label {
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
         position: relative;
         padding-left: 4px;
         color: #181818;
         text-align: right;
       }
       .el-form-item.to-top {
         .el-form-item__label {
           float: none;
         }
       }

       .el-form-item.is-required>.el-form-item__label:before {
         position: absolute;
         left: -1px;
         top: -4px;
       }
       .el-form-item .el-input__inner,.el-form-item .el-textarea__inner {
         color: #000;
       }
       .el-form-item.is-success .el-input__inner,
       .el-form-item.is-success .el-textarea__inner{
         border-color: #dcdfe6;
         color: #000;
       }
       .el-form-item.is-success .el-input__inner:focus,
       .el-form-item.is-success .el-textarea__inner:focus {
        border-color: var(--primary, #409EFF);
       }
       .rc-table-run {
         height: 100%;
       }
     }
     .rc-rich-box-runtime{
       .el-form-item{
         .component-explain-tooltip {
           position: absolute;
           left: 100px;
           top: 8px;
         }
       }
       >.el-form-item.to-left{
         height: 100%;
         .rc-rich-box-name {
           width: 14%;
           padding-left: 0px;
           .required {
             color: #F56C6C;
             position: absolute;
             left: -1px;
             top: -4px;
           }
         }
         .component-explain-tooltip {
           position: relative;
           left: 6px;
           top: 1px;
         }
         .el-form-item__content {
           display: flex;
           align-items: center;
           padding-left: 2px;
         }
         >.el-form-item__content{
           height: 100%;
         }
       }
       >.el-form-item.hidden{
         height: 100%;
         .rc-rich-box-name {
           display: none;
           padding-left: 0px;
           .required {
             color: #F56C6C;
             position: absolute;
             left: -1px;
             top: -4px;
           }
         }
         .component-explain-tooltip {
           position: relative;
           left: -12px;
           top: 0px;
         }
         .el-form-item__content {
           display: flex;
           align-items: center;
           padding-left: 2px;
         }
         >.el-form-item__content{
           height: 100%;
         }
       }
     }
     .isDisabled{

       .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
         content: '';
         color: #ffffff;
       }
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-form.vue